import apiUrl from "../../../../utils/settings";

export const poBaseProductDetailsUrl = () => {
  return apiUrl + '/order-booking/po-base-product-details';
};
export const createOrderUrl = () => {
  return apiUrl + '/order-booking/create-booking-order';
};
export const modifyOrderUrl = () => {
  return apiUrl + '/order-booking/edit-order-booking';
};
export const deleteOrderUrl = () => {
  return apiUrl + '/order-booking/delete-booking-order';
};
export const paginatePOUrl = () => {
  return apiUrl + '/order-booking/paginated';
};
export const attachedDPUrl = () => {
  return apiUrl + '/order-booking/get-orders-by-order-booking-id';
};